export enum ErrorCode {
  SwitchDeviceNoUsers = 5001,
  SwitchDeviceUserDoesNotExist = 5002
}
